import {
    Button, Flex, HStack, IconButton, Link, Menu,
    MenuButton, MenuItem, MenuList, Modal, ModalBody,
    ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay,
    Spacer, Text, useDisclosure
} from '@chakra-ui/react';

import {
    React,
    useEffect
} from 'react';

import {
    Link as RouterLink
} from "react-router-dom";

import { ExternalLinkIcon } from "@chakra-ui/icons";

import {
    // FaCube,
    // FaFont,
    // FaPalette,
    // FaTree,
    FaHome,
    FaQuestion,
    // FaThermometerHalf,
} from 'react-icons/fa';

import {
    GiHamburgerMenu, GiToolbox
} from "react-icons/gi";

import { RiSoundModuleFill } from "react-icons/ri";

import { SplatoonIcon } from "../icons/SplatoonIcon";
import { TaikoIcon } from '../icons/TaikoIcon';

import { SwitchColorModeButton } from './ToggleColorModeButton';

export const AppMenuButtons = (props) => {

    const { isOpen, onOpen, onClose } = useDisclosure();

    useEffect(() => {
        let legacyFlag = "alreadyVisited" + props.pageLabel;
        if (localStorage.getItem(legacyFlag) != null) {
            localStorage.removeItem(legacyFlag);
        }
        let appVersion = localStorage.getItem("appVersion" + props.pageLabel);
        if (appVersion !== props.appVersion) {
            localStorage.setItem("appVersion" + props.pageLabel, props.appVersion);
            onOpen();
        }
    }, [onOpen, props.pageLabel, props.appVersion]);

    return (
        <Flex position="fixed" top="12px" left="12px" right="12px" zIndex="10">
            <NavMenu />
            <Spacer />
            <HStack>
                {props.customComponent}
                <IconButton
                    size="md"
                    fontSize="lg"
                    aria-label={"Help"}
                    // variant="ghost"
                    color="current"
                    onClick={props.children !== undefined && props.modalHeader !== undefined ? onOpen : undefined}
                    icon={<FaQuestion />}
                />
                <SwitchColorModeButton />
            </HStack>
            <Modal isOpen={isOpen} onClose={onClose} isCentered>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>{props.modalHeader}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {props.children}
                    </ModalBody>
                    <ModalFooter>
                        <Text fontSize="xs" color="gray">v{props.appVersion}</Text>
                        <Spacer />
                        <Button colorScheme="blue" mr={3} onClick={onClose}>
                            Close
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </Flex>
    );
};

export const NavMenu = () => {
    return <Menu>
        <MenuButton
            as={IconButton}
            aria-label='Options'
            icon={<GiHamburgerMenu />}
        // variant='outline'
        />
        <MenuList>
            <Link as={RouterLink} to="/" style={{ textDecoration: 'none' }}>
                <MenuItem icon={<FaHome />} >
                    Home
                </MenuItem>
            </Link>
            <Link as={RouterLink} to="/box" style={{ textDecoration: 'none' }}>
                <MenuItem icon={<GiToolbox />} >
                    Box Generator
                </MenuItem>
            </Link>
            <Link as={RouterLink} to="/splatoon3" style={{ textDecoration: 'none' }}>
                <MenuItem icon={<SplatoonIcon />}>
                    Splatoon 3 Calendars
                </MenuItem>
            </Link>
            <Link isExternal as={RouterLink} to="https://github.com/ShikyC/Taiko-Drum-Controller-Arduino" style={{ textDecoration: 'none' }}>
                <MenuItem icon={<TaikoIcon />}>
                    Taiko Controller <ExternalLinkIcon />
                </MenuItem>
            </Link>
            <Link as={RouterLink} to="/taiko" style={{ textDecoration: 'none' }}>
                <MenuItem icon={<RiSoundModuleFill />}>
                    Taiko Controller Test
                </MenuItem>
            </Link>
            {/* <Link as={RouterLink} to="/climate" style={{ textDecoration: 'none' }}>
                <MenuItem icon={<FaThermometerHalf />}>
                    Home Climate
                </MenuItem>
            </Link> */}
        </MenuList>
    </Menu>;
}
